/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RotatableOAuthAppTypeEnum } from './rotatableOAuthAppTypeEnum';
import { RolloutType } from './rolloutType';


export interface OAuthAppRotateActionSpec { 
    type?: RolloutType;
    /**
     * Types of OAuth app which need to be rotated
     */
    oauth_app_types: Array<RotatableOAuthAppTypeEnum>;
}
export namespace OAuthAppRotateActionSpec {
}


